import React from 'react';
import { Modal } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setOpenModales } from '../../store/global';
import { useWindowSize } from '../../hooks/useWindowSize';

export const ModalGlobal = props => {
  const {
    children,
    title,
    idToOpen,
    forceOpen,
    blurBackdrop = false,
    width,
    maxWidthClass,
    onClose,
  } = props;

  const isModalOpen = useSelector(state => state.global.openModales);
  const isMobile = useSelector(state => state.global.isMobile);
  const dispatch = useDispatch();

  const windowSize = useWindowSize();

  React.useEffect(() => {
    return () => {
      if (idToOpen) {
        dispatch(setOpenModales({ id: idToOpen, open: false }));
      }
    };
  }, [dispatch, idToOpen]);

  return (
    <Modal
      open={isModalOpen[idToOpen] === true}
      onClose={() => {
        if (forceOpen) return;
        onClose?.();
        dispatch(setOpenModales({ id: idToOpen, open: false }));
      }}
      BackdropProps={
        blurBackdrop
          ? {
              sx: {
                backdropFilter: 'blur(6px)',
                backgroundColor: 'rgba(0,0,0,0.35)',
              },
            }
          : undefined
      }
    >
      <div
        data-modal-root='true'
        style={{
          width: isMobile ? windowSize.width - 20 : (width ?? 600),
        }}
        className={`${
          maxWidthClass || 'max-w-3xl'
        } text-contrast flex flex-wrap relative rounded shadow absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-main`}
      >
        <div className='h-full w-full rounded bg-primary-d bg-opacity-60'>
          {title && (
            <div className='w-full bg-primary-d rounded-tl rounded-tr px-1 py-05 text-center font-condensed text-lg font-bold'>
              {title}
            </div>
          )}
          <div
            className='p-1 overflow-y-auto overflow-x-hidden w-full'
            style={{ maxHeight: windowSize.height - 100 }}
          >
            {children}
          </div>
        </div>
      </div>
    </Modal>
  );
};
